import React from 'react';
import './SearchStatus.css';

const SearchStatus = ({
    type = 'no-route',
    customTitle,
    customDescription,
    showButton = true,
    isFullScreen = false
}) => {
    if (type === 'no-route') {
        return (
            <div className={`search-status-wrapper no-route-page ${isFullScreen ? 'is-fullscreen' : ''}`}>
                <div className="status-content">
                    <div className="status-image-container">
                        <img
                            src="/no-route-img.png"
                            alt="No routes available"
                            className="status-illustration"
                        />
                    </div>

                    <h2 className="status-title">{customTitle || "No routes available for your search"}</h2>
                    <p className="status-description">
                        {customDescription || "We couldn’t find any travel routes matching your selected locations and dates."}
                    </p>
                    {showButton && (
                        <button className="status-button search-different-date" onClick={() => window.location.reload()}>
                            Search for a different date
                        </button>
                    )}
                </div>
            </div>
        );
    }

    if (type === 'error') {
        return (
            <div className="search-status-wrapper error-page">
                <div className="status-content">
                    <div className="status-image-container">
                        <img
                            src="/route-error.png"
                            alt="Something went wrong"
                            className="status-illustration"
                        />
                    </div>

                    <h2 className="status-title">Something went wrong</h2>
                    <p className="status-description">
                        We couldn’t complete your search due to a temporary issue. Please try again.
                    </p>
                    <button className="status-button secondary" onClick={() => window.location.reload()}>
                        Reload
                    </button>
                </div>
            </div>
        );
    }

    return null;
};

export default SearchStatus;
